import {Injectable} from '@angular/core';
import {UserManager, UserManagerSettings, User} from 'oidc-client-ts';
import {environment} from '../../environments/environment';
import {BehaviorSubject, from, Observable, tap} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private manager = new UserManager(getClientSettings());
  private user: User = null;
  private userSubject: BehaviorSubject<any> = new BehaviorSubject(this.user);
  public currentUserStatus$: Observable<any> = this.userSubject.asObservable();

  constructor() {
    this.manager.getUser().then(user => {
      // this.user = user;
      this.setUser(user);
    });
    // Oidc.Log.level = Oidc.Log.DEBUG;
    // Oidc.Log.logger = console;
  }

  isLoggedIn(): boolean {
    return this.user != null && !this.user.expired;
  }

  getClaims(): any {
    return this.user.profile;
  }

  getAuthorizationHeaderValue(): string {
    return `${this.user.token_type} ${this.user.id_token}`;
  }

  startAuthentication(): Promise<void> {
    return this.manager.signinRedirect();
  }

  completeAuthentication(): Promise<void> {
    return this.manager.signinRedirectCallback().then(user => {
      this.setUser(user);
    });
  }

  /*silentSignIn(): Promise<void>{
    return this.manager.signinSilent().then(user => {
      this.user = user;
    });
  }*/

  silentSignIn(): Observable<any>{
    return from(this.manager.signinSilent()).pipe(tap(user => {
      this.setUser(user);
    }));
  }

  private setUser(user): void {
    this.user = user;
    this.userSubject.next(this.user);
  }

}

export function getClientSettings(): UserManagerSettings {
  return {
    authority: environment.auth.authority,
    client_id: environment.auth.client_id,
    redirect_uri: window.location.origin + environment.auth.redirect_uri,
    post_logout_redirect_uri: window.location.origin + '',
    response_type: 'code',
    scope: 'openid profile offline_access email',
    filterProtocolClaims: true,
    loadUserInfo: false,
    extraQueryParams: {
      domain_hint: environment.auth.domain_hint
    }
  };

/*export function getClientSettings(): UserManagerSettings {
  // tweak by location
  const envRedirectUri =  window.location.origin + environment.auth.redirect_uri;
  const envPostLogoutRedirectUri = window.location.origin + '';
  let authority;
  let envClientId;
  let envDomainHint;
  switch (window.location.hostname) {
    case 'localhost':
    case 'feaas-ui-stg.apps.pcfepgstg1mi.gm.com': {
      authority = environment.auth.authority;
      envClientId = environment.auth.client_id;
      envDomainHint = environment.auth.domain_hint;
      break;
    }
    default: {
      envClientId = '';
      envDomainHint = '';
    }
  }

  return {
    authority: `${authority}`,
    client_id: `${envClientId}`,
    redirect_uri: `${envRedirectUri}`,
    post_logout_redirect_uri: `${envPostLogoutRedirectUri}`,
    response_type: 'code',
    scope: [
      'email',
      'offline_access',
      'openid',
      'profile',
    ].join(' '),
    filterProtocolClaims: true,
    automaticSilentRenew: true,
    loadUserInfo: false,
    extraQueryParams: {
      domain_hint: `${envDomainHint}`
    }
  };*/
}
